class ContactDrawer extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: none; /* Empieza oculto */
                }

                :host(.ready) {
                    display: block; /* Solo visible cuando esté preparado */
                }
                
                .overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1;
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity 0.5s ease, visibility 0.5s ease;
                }
                
                .overlay.visible {
                    opacity: 1;
                    visibility: visible;
                    z-index: 100;
                }
                
                .drawer {
                    position: fixed;
                    top: 0;
                    right: -100%;
                    width: 100%;
                    height: 100%;
                    max-width: 550px;
                    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
                    z-index: 0;
                    transition: right 0.5s ease;
                    display: flex;
                    flex-direction: column;
                    background-color: inherit;
                    padding: 20px;
                    box-sizing: border-box;
                }
                
                .drawer.visible {
                    right: 0;
                    z-index: 101;
                }
                
                .drawer-header {
                    position: relative;
                }

                .drawer-footer {
                    flex-shrink: 0;
                }
                
                .close-btn {
                    position: absolute;
                    top: 0;
                    right: 0;
                    background: none;
                    border: none;
                    font-size: 1.5rem;
                    cursor: pointer;
                    color: inherit;
                }

                .close-btn svg {
                    color: inherit;
                }
                                 
                .drawer-content {
                    flex-grow: 1;
                    overflow-y: auto;
                }
                
                @media (max-width: 500px) {
                    .drawer {
                        width: 100%;
                        right: -100%;
                    }
                }
            </style>
            
            <div class="overlay"></div>
            
            <div class="drawer">
                <div class="drawer-header">
                    <slot name="drawer-header"></slot>
                    <button class="close-btn">
                       <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-close" viewBox="0 0 16 16">
                        <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="2"/>
                        </svg>
                    </button>
                </div>
                <div class="drawer-content">
                    <slot name="drawer-content"></slot>
                </div>
                <div class="drawer-footer"> 
                    <slot name="drawer-footer"></slot>
                </div>
            </div>
        `;
        
        this.isOpen = false;
    }
    
    connectedCallback() {
        this.shadowRoot.querySelector('.overlay').addEventListener('click', () => this.close());
        this.shadowRoot.querySelector('.close-btn').addEventListener('click', () => this.close());
        
        document.querySelectorAll('.open-drawer-btn').forEach(btn => {
            btn.addEventListener('click', () => this.open());
        });

        this.classList.add('ready');
        this.style.display = 'block';
    }
    
    open() {
        this.isOpen = true;
        this.shadowRoot.querySelector('.overlay').classList.add('visible');
        this.shadowRoot.querySelector('.drawer').classList.add('visible');
        document.body.style.overflow = 'hidden';
    }
    
    close() {
        this.isOpen = false;
        this.shadowRoot.querySelector('.overlay').classList.remove('visible');
        this.shadowRoot.querySelector('.drawer').classList.remove('visible');
        document.body.style.overflow = '';
    }
    
    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
}

customElements.define('contact-drawer', ContactDrawer);


// FORM POSTED 
document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const contactPosted = urlParams.get('contact_posted');

    if (contactPosted === 'true') {
        const contactDrawer = document.querySelector('contact-drawer');
        const accordion = document.querySelector('#contact-accordion'); 
        if (contactDrawer) {
            // Nos aseguramos de que esté "ready"
            if (contactDrawer.classList.contains('ready')) {
                contactDrawer.open();
                contactDrawer.classList.add('contact-posted');
                accordion.setAttribute('open', '');
                accordion.setAttribute('aria-expanded', 'true');
            } else {
                // Si todavía no está listo, esperamos un poco
                const observer = new MutationObserver(() => {
                    if (contactDrawer.classList.contains('ready')) {
                        contactDrawer.open();
                        observer.disconnect();
                    }
                });
                observer.observe(contactDrawer, { attributes: true, attributeFilter: ['class'] });
            }
        }
    }
});

